import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { AsignacionDistribucionIncentivosService } from '../../services/asignacion-y-distribucion-incentivos.service';
import { ConfiguracionTiposVariablesIncentivosService } from '../../services/configuracion-tipos-variables-incentivos.service';
import { formatDate } from '@angular/common';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';



@Component({
  selector: 'app-asignacion-y-distribucion-incentivos',
  templateUrl: './asignacion-y-distribucion-incentivos.component.html',
  styleUrls: ['./asignacion-y-distribucion-incentivos.component.css']
})
export class AsignacionDistribucionIncentivosComponent implements OnInit {

  tituloCard: string = 'Asignación y Distribución Incentivos';
  tituloForm: string = 'Lista De Asignación y Distribución Incentivos';

  formulario: FormGroup;
  formularioFiltroTipoDeVendedores: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;
  isCreate: boolean = false;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstadosFiltro: any[] = [
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbComisiones: any[] = [
    {
      clave: '1',
      valor: 'FIJA'
    },
    {
      clave: '2',
      valor: 'COMISIONES'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _tipoDeVendedor: TipoDeVendedorService,
    private _altaDeVendedor: AltaDeVendedoresService,
    private _serviciosCRUD: AsignacionDistribucionIncentivosService,
    private _tipoDeVariables: ConfiguracionTiposVariablesIncentivosService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({

      asignacionId: ['', []],
      tipoAsignacion: ['', []],
      tipoVendedorId: ['', []],
      vendedorId: ['', []],
      variableId: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', []],
      ganancia: ['', [Validators.required]],
      cumplimiento: ['', [Validators.required, Validators.min(0), Validators.max(100)]],

      usuarioCarga: ['', []],
      fechaCarga: ['', []],
      sueldoVariable: ['', []],
      dolares: ['', []],
      descripcionVariable: ['', []],
      descripcionVendedor: ['', []],
      nombreVendedor: ['', []],
    });

    this.formularioFiltroTipoDeVendedores = this.fb.group({
      idTipoVendedor: ['', []],
    });

    this.formularioFiltroTipoDeVendedores.get('idTipoVendedor').valueChanges
      .subscribe((resp) => {

        this.listaVacia = true;
        this.loading = true;

        console.log("getTodoPorTipoDeVendedor", resp)
        this._serviciosCRUD.getTodoPorTipoDeVendedor(resp).subscribe((res: any[]) => {
          console.log("getTodoPorTipoDeVendedor()", res)
          this.loading = false;
          this.listaVacia = (res.length === 0) ? true : false;
          this.rowData = res;
        }, (err) => {
          this.loading = false;
          this.listaVacia = true;
          this.rowData = [];
        });
      });


    this.formulario.get('ganancia').valueChanges
      .subscribe((resp) => {
        this.clacularDolares();
      });

    this.formulario.get('cumplimiento').valueChanges
      .subscribe((resp) => {
        this.clacularDolares();
      });

    // this.formulario.get('tipoVendedorId').valueChanges
    //   .subscribe((resp) => {

    //     if (this.isEdit) {
    //       this.changeTipoVendedor(resp);
    //       this.isEdit = false;
    //       return;
    //     }

    //     this.changeTipoVendedor(resp);

    //     // this.getFormValidationErrors();
    //     // }
    //   });

    this.cargarGridcomponent();

    this.getTiposDeVendedores();
    this.getTiposDeVariables();

  }

  isEdit = false;

  // changeTipoVendedor(tipo, vendedor = null) {
  changeTipoVendedor(vendedor = null) {

    let tipo = this.formulario.get("tipoVendedorId").value;

    console.log("tipo", tipo)
    if (tipo == '' || tipo == 0 || tipo === null) {
      this.listVendedores = [];
      this.listVendedores.push({
        nombreAMostrar: 'TODOS',
        idVendedor: 'todos',
      });

      // this.formulario.get("tipoVendedorId").setValue('');
      this.formulario.get("vendedorId").setValue('todos');
    }
    else {
      this.loading = true;
      this._tipoDeVendedor.getTipoDeVendedoreByID(tipo).subscribe((resp: any) => {
        console.log("getPorVendedorId()", resp)
        if (resp) {
          console.log("PASOOOO", resp.sueldoVariable)
          this.formulario.get('sueldoVariable').setValue(resp.sueldoVariable);
          this.sueldovariable = resp.sueldoVariable;
          this.clacularDolares();
          this.vendedores(vendedor);
        } else {
          this.formulario.get('sueldoVariable').setValue('');
        }
      }, (err) => {
        this.loading = false;
        this.formulario.get('sueldoVariable').setValue('');
      });
    }
  }

  listVendedores;
  vendedores(vendedor = null) {
    console.log("vendedor vendedores()", vendedor)
    this.listVendedores = [];
    this.loading = true;
    this._altaDeVendedor.getTodoPorTipo(this.formulario.get("tipoVendedorId").value).subscribe((res: any[]) => {
      console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listVendedores = res;

      for (let i = 0; i < this.listVendedores.length; i++) {
        this.listVendedores[i].nombreAMostrar = this.listVendedores[i].codigoSap + " - " + this.listVendedores[i].nombreVendedor1;
      }

      this.listVendedores.unshift({
        nombreAMostrar: 'TODOS',
        idVendedor: 'todos',
      });

      setTimeout(() => {
        console.log("vendedor setTimeout", vendedor)
        if (vendedor === null || vendedor === '') {
          this.formulario.get("vendedorId").setValue('todos');
        }
        else {
          this.formulario.get("vendedorId").setValue(vendedor);
        }
      }, 1000);

    }, (err) => {
      this.loading = false;
      this.listVendedores = [];

      this.listVendedores.unshift({
        nombreAMostrar: 'TODOS',
        vendedorId: 'todos',
      });

      this.formulario.get("vendedorId").setValue('todos');

    });
  }

  clacularDolares() {
    if (this.formulario.get("cumplimiento").value <= 0) return;
    if (this.formulario.get("ganancia").value <= 0) return;
    if (this.formulario.get("sueldoVariable").value <= 0) return;

    let suledo = this.formulario.get("sueldoVariable").value;
    let ganancia = this.formulario.get("ganancia").value;

    let dolares = (suledo * ganancia) / 100;

    this.formulario.get("dolares").setValue(dolares);
  }

  listTiposDeVendedores;
  listTiposDeVendedoresFiltro;
  getTiposDeVendedores() {
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;
      this.listTiposDeVendedoresFiltro = res;

      this.listTiposDeVendedoresFiltro.unshift({
        descripcion: 'TODOS',
        idTipo: '',
      });

      this.formularioFiltroTipoDeVendedores.get("idTipoVendedor").setValue('');
    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
    });
  }

  listTiposDeVariables;
  getTiposDeVariables() {
    this.loading = true;
    this._tipoDeVariables.getTodoPorEstado("1").subscribe((res: any[]) => {
      console.log("getTiposDeVariables()", res)
      this.loading = false;
      this.listTiposDeVariables = res.filter(p => p.tipoVariable === "INCENTIVO" || p.tipoVariable === "INCENTIVO_VEHICULAR");
    }, (err) => {
      this.loading = false;
      this.listTiposDeVariables = [];
    });
  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'asignacionId',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo Vendedor',
        field: 'descripcionVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Variable',
        field: 'descripcionVariable',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cumplimiento',
        field: 'cumplimiento',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Ganancia',
        field: 'ganancia',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  sueldovariable;
  nuevo() {
    this.isEdit = false;
    this.isCreate = true;
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Asignación y Distribución Incentivos';

    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    console.log("userData", userData)
    this.formulario.get('usuarioCarga').setValue(userData.login2);
    this.formulario.get('sueldoVariable').setValue(this.sueldovariable);
    this.formulario.get('cumplimiento').setValue(100);

    this.formulario.controls['fechaCarga'].setValue(
      formatDate(new Date(), 'dd-MM-yyyy', 'en')
    );
  }

  cargarEditarVendedor = false;
  editar({ rowData }) {
    this.isEdit = true;
    this.cargarEditarVendedor = true;
    this.isCreate = false;
    console.log("editar", rowData)
    this.commonFormService.abrirFormularioParaGuardar(this);

    rowData.fechaFin = formatDate(new Date(rowData.fechaFin), 'yyyy-MM-dd', 'en');
    // rowData.fechaCarga = formatDate(new Date(rowData.fechaCarga), 'dd-MM-yyyy', 'en');
    rowData.fechaInicio = formatDate(new Date(rowData.fechaInicio), 'yyyy-MM-dd', 'en');

    console.log("rowData", rowData);

    this.formulario.setValue(rowData);
    // document.getElementById('buttonAbrirModal').click();

    if(rowData.tipoVendedorId == 0)
      this.formulario.get("tipoVendedorId").setValue('');
    setTimeout(() => {
      this.changeTipoVendedor(rowData.vendedorId);
    }, 1500);
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      if (this.isCreate) {
        this.guardar();
      }
      else
        this.actualizar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Asignación y Distribución Incentivos';
    this.tituloForm = 'Lista De Asignación y Distribución Incentivos';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo().subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)

    rowData.fechaFin = rowData.fechaFin;
    rowData.fechaInicio = rowData.fechaInicio;

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(rowData),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    console.log("datos llegan", datos);
    datos.fechaCarga = this.isCreate ? datos.fechaCarga.split('-').reverse().join('-') + 'T00:00:00' : datos.fechaCarga;
    datos.fechaInicio = datos.fechaInicio + 'T00:00:00';
    datos.fechaFin = datos.fechaFin ? datos.fechaFin + 'T00:00:00' : '';
    datos.tipoAsignacion = "INCENTIVO";
    datos.vendedorId = datos.vendedorId == 'todos' || datos.vendedorId == null ? null : datos.vendedorId;
    datos.tipoVendedorId = datos.tipoVendedorId ? datos.tipoVendedorId : null;

    console.log("datos van", datos);

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    let datos = this.formulario.getRawValue();
    datos.fechaCarga = this.isCreate ? datos.fechaCarga.split('-').reverse().join('-') + 'T00:00:00' : datos.fechaCarga;
    datos.fechaInicio = datos.fechaInicio + 'T00:00:00';
    datos.fechaFin = datos.fechaFin ? datos.fechaFin + 'T00:00:00' : '';
    datos.tipoAsignacion = "INCENTIVO";
    datos.vendedorId = datos.vendedorId == 'todos' || datos.vendedorId == null ? null : datos.vendedorId;
    datos.tipoVendedorId = datos.tipoVendedorId ? datos.tipoVendedorId : null;

    console.log(datos)
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      this.mostrarFormulario = false;
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  cargar() {

  }

}